module.exports = __webpack_public_path__ + "img/taylorBellCastingHall201027-078.30dff6c7.jpg";